import React from "react";
import PricingField from "./PricingField";
import { TestClaimFormattedPricingData } from "@/types/appTypes/transmissions";

interface PricingProps {
  pricingFields: TestClaimFormattedPricingData;
}

const ResponsePricingSegment: React.FC<PricingProps> = ({ pricingFields }: PricingProps) => {
  /* This iterates over the groups, whereas `PricingFieldComponent`
     maps a single group's fields. */
  const renderedGroups = [];

  for (const [fieldGroupName, fieldGroupFields] of Object.entries(pricingFields)) {
    renderedGroups.push(<PricingField key={fieldGroupName} fieldGroupName={fieldGroupName} fieldGroupFields={fieldGroupFields} />);
  }

  return (
    <div className="response-segment" data-testid="test__response-segment">
      <div className="segment-name" data-testid="test__segment-name">
        Response Pricing
      </div>
      <div>{renderedGroups}</div>
    </div>
  );
};

export default ResponsePricingSegment;
